import React from 'react';

import {BsArrowRight} from 'react-icons/bs';

import {motion} from 'framer-motion';

import {fadeIn} from '../variants';


const services = [
  {
    name:"Oasis Infobyte-FullStack Pizza delivery Website",
    desc:"Developed a MERN stack Pizza delivery website with all basic features of a conventional e-commerce website and orchestrated Pizza customization as a unique feature that leads to 25% increase in customer engagement.",
    link:'learn more',
    to:"https://www.linkedin.com/posts/arunkumara03_oasisinfobyte-internshipproject-fullstackdevelopment-activity-7083834146585784320-jnpe?utm_source=share&utm_medium=member_desktop",
  },
  {
    name:"Website Development team in College Symposium",
    desc:"Assisted in development of our college Symposium website with ReactJs.\n   Worked with Google Firebase to manage user input data improving data retrieval speed by 30%.",
    link:'learn more',
    to:"http://trojans-2023.web.app/",
  },
  {
    name:"Lead the Workshop on Full Stack",
    desc:"Covered a formal overview of full-stack development, emphasizing the connections between frontend and backend components. ",
    link:'learn more',
    to:"https://www.linkedin.com/posts/arunkumara03_webdevelopment-mernstack-fullstackdeveloper-activity-7043650068737925120-JW06?utm_source=share&utm_medium=member_desktop",
  },
  {
    name:"BeTime-A Startup venture",
    desc:"Built a landing page the startup",
    link:'learn more',
    to:"https://be-time.netlify.app/",
  },
]


const Services = () => {
  return (
    <section id="experience" className="section mt-2 lg:mt-20 lg:mb-40">
      <div className="container mx-auto mt-20">
        <div className="flex flex-col lg:flex-row">
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.7 }}
            className="flex-1 h-[600px] lg:w-[50%] lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0"
          >
            <div className="text-right mb-10 lg:mb-0 lg:mr-10">
              <h1 className="h1 text-fuchsia-600 text-[60px] mb-6">Experience</h1>
              <a href="https://asprojects.netlify.app/" target="_blank" rel="noopener noreferrer">
                <button className="btn btn-sm m-0">More on Experience</button>
              </a>
            </div>
          </motion.div>
  
          <div className="flex-2">
            {services.map((service, index) => {
              const { name, desc, link, to } = service;
              return (
                <motion.div
                  variants={fadeIn('left', 0.5)}
                  initial="hidden"
                  whileInView={'show'}
                  viewport={{ once: false, amount: 0.7 }}
                  className="border-b border-white/20 py-6 lg:py-0 lg:h-[146px] lg:mb-[38px] flex flex-col lg:flex-row items-center"
                  key={index}
                >
                  <div className="max-w-[600px] lg:max-w-none lg:mr-6 mb-6 lg:mb-0">
                    <h4 className="text-[20px] tracking-wider font-primary font-semibold mb-2 lg:mb-4">{name}</h4>
                    <p className="font-secondary leading-tight mb-2 lg:mb-0">{desc}</p>
                  </div>
                  <div className="flex items-center">
                    <a href={to} target="_blank" rel="noopener noreferrer" className="btn w-5 h-5 mr-2"><BsArrowRight /></a>
                    <a href={to} className="text-sm">{link}</a>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
  
};

export default Services;
